import {useMutation, useQueryClient} from '@tanstack/react-query';
import ChessRestClient from '@/Api/ChessRestClient';

export type SetProfilePrivacyResponse = {is_private: boolean};

// PATCH /players/me/privacy/ -- owner-only whole-profile privacy toggle
// (Instagram-style). Persists to CCUserSettings.profile_visibility.private
// server-side. Invalidates the owner's profile queries on success so the
// header toggle / "Private" badge reflect the new state without a manual
// refetch. `username` is the owner's own username (their profile query key).
export const useSetProfilePrivacyApi = (username?: string | null) => {
  const qc = useQueryClient();
  return useMutation(
    async (isPrivate: boolean): Promise<SetProfilePrivacyResponse> =>
      (await ChessRestClient.patch('/players/me/privacy/', {private: isPrivate}))
        .data,
    {
      onSuccess: () => {
        if (username) {
          qc.invalidateQueries(['playerProfile', username]);
        }
        qc.invalidateQueries(['playerProfile', 'me']);
      },
    },
  );
};

export default useSetProfilePrivacyApi;
